import { render, staticRenderFns } from "./ZoneBadge.vue?vue&type=template&id=1db58152&scoped=true&"
import script from "./ZoneBadge.vue?vue&type=script&lang=ts&"
export * from "./ZoneBadge.vue?vue&type=script&lang=ts&"
import style0 from "./ZoneBadge.vue?vue&type=style&index=0&id=1db58152&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db58152",
  null
  
)

export default component.exports